import React, { useContext } from "react"; //
import {
  //
  bearlog,
  BearDiv,
  BearList,
  BearBorder,
} from "@sillyscribe95/bear-ui-web";
import { MainContext } from "../context/MainContext";
import { chordKeyDict } from "../consts/chordConst";
import { BearListPopover, BearPopover, PopList } from "./GlobalComps";

export function KeyChoose() {
  const {
    //
    shiftpic,
    picho,
    pitchPlus,
  } = useContext(MainContext);

  const niaae = pitchPlus;
  const osdwr =
    //
    // Array.from(Array(8).keys());
    Array.from({ length: 12 }, (_, i) => i + 1);

  const sdfwsa = {
    bearName: "rightheade",
    list: osdwr,
    // itemConfig: nidqws,
    dictvar: chordKeyDict,
    chosenItem: niaae,
    chosenConfig: {
      style: { background: "red" },
    },
    renderItem: fdgsd,
    onClick: sdfgdffs,
  };

  function sdfgdffs({ itemName }) {
    let oaskdwe = itemName;
    bearlog.lug("___ oaskdwe ___", oaskdwe);
    shiftpic(oaskdwe);
  }

  function fdgsd(bfsfdsg) {
    bearlog.lug("___ bfsfdsg ___", bfsfdsg);
    return adfrea(bfsfdsg);
  }

  function adfrea({ current, itemName, chord }) {
    const jqease =
      //
      chord;
    // BearFloat({
    //   center: chord,
    //   topRight: "Select",
    // });

    return chord;
  }

  const adwe = {
    // style: {
    //   overflow: "scroll",
    //   height: "240px",
    // },
    // class
  };

  const okas = {
    itemStyle: { width: "60px" },
    ...adwe,
    selected: chordKeyDict[niaae],
    renderItem: fdgsd,
    ...sdfwsa,
  };

  // const ssdfse = {

  //   // current: true,
  //   selected:chordKeyDict[niaae]
  //   renderItem: fdgsd,
  // };

  let sfdgsre = PopList(okas);

  return sfdgsre;
}
